// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://emwcpelxqwqugxgowntl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtd2NwZWx4cXdxdWd4Z293bnRsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1Nzg3NjQsImV4cCI6MjA2MDE1NDc2NH0.vc403ObzHJlHs22QuPObm-MC-Vzz3i-OiFm7zKhuJvE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);